// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__26Ykv","row":"styles_row__2F3pg"};